import { ref } from 'vue';
import { $get } from '../composables/useApi';
import { streamId, objectId } from '../speckleConstants';

const items = ref({
  isLoading: true,
  items: []
});

const roomIds = ref([]);

async function getItems() {
  if (!items.value.isLoading) {
    return;
  }

  const response = await $get(`/facility/${streamId}/${objectId}/`);

  if (response?.error) {
    console.error('Error getting items');
    return;
  }

  roomIds.value = response.rooms.map(room => room.id);

  items.value.items = response.levels.map(item => ({
    id: item,
    name: item,
    isOpened: false,
    items: response.rooms.filter(room => room.level === item)
  }));
  items.value.isLoading = false;
}

export {
  roomIds,
  items,
  getItems
};
